<template>
  <div class="additional-service" :class="{'additional-service--selected': anySelected}">
    <div class="additional-service__image" @click="toggle('servicesModal')">
      <img :src="backgroundImage">
    </div>
    <div class="additional-service__body" @click="toggle('servicesModal')">
      <div class="additional-service__body--informations">
        <div v-if="anySelected" class="selected-count"><h3>Dodano</h3></div>
        <span v-else>{{ subtitle }}</span>

        <h3>{{ title }}</h3>
        <div class="additional-service__body--details">
          <hr>
          <span v-if="anySelected">Szczegóły</span>
        </div>
      </div>
      <div class="additional-service__body--bottom">
        <p v-if="anySelected">{{ buttonMoreText }}</p>
        <p v-else>{{ buttonText }}</p>
        <span>+</span>
      </div>
    </div>

    <ServiceModal v-if="servicesModal" @close="toggle('servicesModal')"
      :style="{ opacity: insurancesDetailsModal ? '0' : '1' }"
      :modalTitle="value.ModalTitle" :headline="modalSubtitle" :serviceTitle="title"
      :serviceCode="value.Code" :storedSelectedServices="selectedServices" :storedAdditionalServices="additionalServices"
      @selected="applySelected" v-model="services" @toggleInsurancesDetailsModal="toggleInsurancesDetailsModal" />

    <DetailsModal v-if="insurancesDetailsModal" class="details-modal"
      @close="toggleInsurancesDetailsModal" :title="detailsModalTitle" />

    <ModalRoot v-if="recalculationModal" class="recalculation-modal modal-dialog--small"
      :closeByClickingOutside="false" @close="toggle('recalculationModal')">
      <div class="modal-dialog__content">
        <Loader v-if="requestPending" custom="spinner" class="recalculation-modal__loader" />
        <div v-if="requestPending" class="recalculation-modal__headline">Dodajemy Twoje usługi dodatkowe do zamówienia!</div>
        <hr>
      </div>
    </ModalRoot>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapActions, mapGetters } from 'vuex'

import DetailsModal from '@/components/booking/additionalServices/Details'
import ServiceModal from '@/components/booking/additionalServices/Modal'
import OfferExpiredLogic from '@/components/booking/logic/OfferExpired'
import ServicesLogic from '@/components/booking/logic/Services'
import OfferExpired from '@/components/booking/OfferExpired'
import { CHILD_CODE, INFANT_CODE } from '@/components/booking/types'
import Loader from '@/components/Loader'
import ModalRoot from '@/components/ModalRoot'
import DropdownHandler from '@/components/search/DropdownHandler'
import { API, AdditionalServicesRequest } from '@/modules/api'
import { DataLayerEvent, pushEvent } from '@/modules/datalayer/helpers'
import Store from '@/store/index'
import {
  SET_OFFER,
  SET_SELECTED_SERVICE,
  SET_ADDITIONAL_SERVICES,
  UPDATE_ADDITIONAL_SERVICES,
} from '@/store/mutation-types'
import MediaDetector from '@/utils/MediaDetector'

const OFFER_MUTATION = `Booking/${SET_OFFER}`
const SELECTED_SERVICE_MUTATION = `Booking/${SET_SELECTED_SERVICE}`
const ADDITIONAL_SERVICES_MUTATION = `Booking/${SET_ADDITIONAL_SERVICES}`
const UPDATE_SERVICES_MUTATION = `Booking/${UPDATE_ADDITIONAL_SERVICES}`

@Component({
  store: Store,
  mixins: [
    DropdownHandler,
    MediaDetector,
    ServicesLogic,
    OfferExpiredLogic,
  ],
  components: {
    ServiceModal,
    ModalRoot,
    DetailsModal,
    Loader,
    OfferExpired,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      selectedServices: 'Booking/getSelectedServices',
      additionalServices: 'Booking/getAdditionalServices',
      sessionExpired: 'Booking/getSessionExpired',
    }),
    servicesModal () {
      return this.dropdowns.servicesModal && !this.sessionExpired
    },
    recalculationModal () {
      return this.dropdowns.recalculationModal && !this.sessionExpired
    },
    insurancesDetailsModal () {
      return this.dropdowns.insurancesDetailsModal && !this.sessionExpired
    },
  },
  methods: {
    ...mapActions({
      setOffer: OFFER_MUTATION,
      setSelectedService: SELECTED_SERVICE_MUTATION,
      setAdditionalServices: ADDITIONAL_SERVICES_MUTATION,
      updateAdditionalServices: UPDATE_SERVICES_MUTATION,
    }),
  },
})
export default class Service extends Vue {
  requestPending = false
  dropdowns = {
    servicesModal: false,
    recalculationModal: false,
    insurancesDetailsModal: false,
  }

  get anySelected () {
    return this.services.some(service => service.selected)
  }

  get selectedCount () {
    return this.services.filter(el => el.selected).length
  }

  get backgroundImage () {
    return this.value.BackgroundUrl
  }

  get subtitle () {
    return this.value.Subtitle
  }

  get title () {
    return this.value.Title
  }

  get buttonText () {
    return this.value.OptionText
  }

  get buttonMoreText () {
    return this.value.AnotherOptionText
  }

  get modalSubtitle () {
    return this.value.ModalSubtitle
  }

  get detailsModalTitle () {
    return !this.isFluidDesktop ? 'Szczegóły' : 'Szczegóły ubezpieczenia'
  }

  get requestData () {
    return {
      offerCode: this.offer.OfferCode,
      adults: this.offer.AdultsCount,
      children: this.offer.ChildrenCount,
      child1: this.getChildBirthdayOf(1),
      child2: this.getChildBirthdayOf(2),
      child3: this.getChildBirthdayOf(3),
      child4: this.getChildBirthdayOf(4),
      child5: this.getChildBirthdayOf(5),
      child6: this.getChildBirthdayOf(6),
      services: this.selectedServices,
    }
  }

  get children () {
    return this.offer.Persons
      .filter(person => person.Gender == CHILD_CODE || person.Gender == INFANT_CODE)
  }
  
  /**
   * We can't use 'toggle' mixin method because its causing close previously opened modal
   */
  toggleInsurancesDetailsModal () {
    this.dropdowns.insurancesDetailsModal = !this.dropdowns.insurancesDetailsModal
  }

  getChildBirthdayOf (index) {
    if (this.children[index - 1]) return moment(this.children[index - 1].Birthdate).format('YYYYMMDD')
    else return null
  }

  offerRecalculationErrorHandler ({ response }) {
    this.toggle('recalculationModal')
    this.toggle('processingDataError')
    this.setOfferExpiredData(response)
    this.requestPending = false
  }

  applySelected (services) {
    this.emitDataLayerEvent(services)
    this.toggle('servicesModal')
    this.toggle('recalculationModal')
    this.setSelectedService(services)
    this.requestPending = true

    return new API()
      .getBookingAdditionalServices(AdditionalServicesRequest.fromSelectedServices(this.requestData))
      .then(response => this.processOfferRecalculation(response, services))
      .then(() => { this.requestPending = false })
      .catch(this.offerRecalculationErrorHandler)
  }

  processOfferRecalculation ({ offer }, services) {
    log.debug(`__Mutation.Offer__: ${OFFER_MUTATION}`, offer)

    this.setOffer(offer)
    this.updateAdditionalServices(services)
    this.toggle('recalculationModal')
  }

  emitDataLayerEvent (services) {
    /* eslint-disable */
    try {
      const selected = services.filter(item => item.selected)
      const eventData = {
        item_name: this.offer['HotelName'],
        item_id: this.offer['OfferCode'],
        price: parseFloat(this.offer['TotalPrice']),
        quantity: 1,
        adults: this.offer['AdultsCount'],
        children: this.offer['ChildrenCount'],
        departure_date: this.offer['DepartureDate'],
        return_date: this.offer['ReturnDate'],
        hotel_standard: this.offer['BoardStandardDesc'],
        offer_type: this.offer['Type'],
      }
      selected.forEach(item => {
        const [ event ] = DataLayerEvent.service(eventData)
        event.ecommerce.service_code = this.value['Code']
        event.ecommerce.service_type = this.value['Title']
        event.ecommerce.service_name = item['Title']
        event.ecommerce.service_price = item['ServicePriceAdult']
        event.ecommerce.currency = 'PLN'
        event.ecommerce.value = parseFloat(this.offer["TotalPrice"])
        pushEvent(event)
      })
      
    } catch (error) {
      console.error(error)
    }
    /* eslint-enable */
  }
}
</script>

<style lang="scss" scoped>
.additional-service {
  position: relative;
  min-height: 80px;
  overflow: hidden;

  &:hover &__body--bottom {
    background-color: #EB2F7F;    
  }

  &:hover &__image {
    img {
      transform: scale3d(1.15, 1.15, 1);
    }

    &::before {
      opacity: 1;
    }
  }

  &__image::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(231, 31, 108, .4);
    opacity: 0;
    z-index: 1;
    transition: .3s ease-in-out all;
  }

  &--selected &__image::before {
    opacity: 1;
  }

  &__body {
    position: absolute;
    bottom: 0;
    width: 100%;
    cursor: pointer;
    z-index: 2;
  }

  &__body--bottom {
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 22px 0 20px;
    background-color: #EA006C;
    color: #fff;
    text-transform: uppercase;
    font-weight: bold;
    transition: .3s ease-in-out all;

    p {
      font-size: 1.15em;
      line-height: 1.2em;
      max-width: 150px;

      @include mediaFluid(tablet) {
        margin-top: -4px;
      }
    }

    span {
      font-size: 41px;
      line-height: 25px;
      margin-top: 3px;
      margin-right: -6px;

      @include mediaFluid(tablet) {
        margin-top: -1px;
        
      }
      
      @include mediaFluid(desktop) {
        margin-top: -1px;
        margin-right: 0px;
      }
    }
  }

  &__body--informations {
    margin-bottom: 26px;
    padding: 0 20px;
    color: #fff;
    text-transform: uppercase;
    display: none;

    @include mediaFluid(tablet) {
      display: block;
    }

    h3 {
      margin: 0 0 13px -2px;
      font-size: 1.5em;
    }

    > span {
      font-size: .85em;
      margin-bottom: 6px;
      display: flex;
    }

    .selected-count {
      font-weight: bold;
      margin-left: -2px;

      h3 {
        margin: 2px 0 2px;
      }
    }
  }

  &__body--details {
    display: flex;
    align-items: flex-start;
    text-transform: uppercase;
    font-size: .85em;

    hr {
      width: 40px;
      height: 6px;
      border: none;
      background-color: #fff;
      margin: 1px 10px 0 0;
    }
  }

  &__image {
    display: none;
    position: relative;
    cursor: pointer;

    @include mediaFluid(tablet) {
      display: flex;

    }

    @include mediaFluid(desktop) {
      height: 260px;
    }

    img {
      width: 100%;
      height: 233px;
      transition: .3s ease-in-out all;
      transform: scale3d(1, 1, 1);

      @include mediaFluid(tablet) {
        display: flex;
      }

      @include mediaFluid(desktop) {
        height: 260px;
        margin-top: -50px;
      }
    }
  }
}

.recalculation-modal {
  &__headline {
    font-family: 'Gotham';
    font-weight: bold;
    font-size: 25px;
    color: #005CA9;
    text-transform: uppercase;
    line-height: 38px;
    text-align: center;

    @include media(tablet) {
      font-size: 36px;
    }
  }

  &__loader {
    width: auto;
    height: auto;
    position: relative;
    left: auto;
    transform: translate(0, -20%);
  }

  hr {
    margin: 8px auto 0;
    width: 54px;
    height: 6px;
    background-color: #005CA9;
    border: none;
  }
}
</style>

<style lang="scss">
.details-modal .modal-dialog__content {
  align-items: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/booking/additionalServices/Service.vue